import { create } from 'zustand';

export type GuideWaitFor = 'click' | 'speak_next' | 'either';

export type GuideStep = {
  id: string;
  say: string;
  title?: string | null;
  highlight?: string | null;
  href?: string | null;
  wait_for?: GuideWaitFor;
};

export type ActiveGuide = {
  id: string;
  title: string;
  summary?: string;
  steps: GuideStep[];
  stepIndex: number;
};

type GuideStore = {
  guide: ActiveGuide | null;
  startGuide: (guide: Omit<ActiveGuide, 'stepIndex'> & { stepIndex?: number }) => void;
  advanceGuide: () => {
    finished: boolean;
    completedStep: GuideStep | null;
    nextStep: GuideStep | null;
  };
  clearGuide: () => void;
};

export const useVoiceGuideStore = create<GuideStore>((set, get) => ({
  guide: null,
  startGuide: (guide) =>
    set({
      guide: {
        id: guide.id,
        title: guide.title,
        summary: guide.summary,
        steps: guide.steps,
        stepIndex: guide.stepIndex ?? 0,
      },
    }),
  advanceGuide: () => {
    const current = get().guide;
    if (!current) {
      return { finished: true, completedStep: null, nextStep: null };
    }
    const completedStep = current.steps[current.stepIndex] ?? null;
    const nextIndex = current.stepIndex + 1;
    if (nextIndex >= current.steps.length) {
      set({ guide: null });
      return { finished: true, completedStep, nextStep: null };
    }
    set({
      guide: {
        ...current,
        stepIndex: nextIndex,
      },
    });
    return {
      finished: false,
      completedStep,
      nextStep: current.steps[nextIndex] ?? null,
    };
  },
  clearGuide: () => set({ guide: null }),
}));
